import { css } from "@emotion/react";
import styled from "@emotion/styled";
import {
  Button as FindOutMoreButton,
  ButtonContainer as FindOutMoreButtonContainer,
  Container as FindOutMoreContainer,
  Message as FindOutMoreMessage,
  MessageContainer as FindOutMoreMessageContainer,
  StyledNewsletterIcon as FindOutMoreNewsletterIcon,
} from "scmp-sdk/components/newsletter/newsletter-widget/find-out-more/styles";
import type { ThemeType } from "scmp-sdk/components/newsletter/newsletter-widget/types";

import { theme as breakpointTheme } from "shared/lib/styles";

import { Bottom as SignUpNewsletterBottom } from "./homepage-theme-sign-up-newsletter/styles";

export const theme = {
  findOutMore: {
    titleFontStyle: "small",
  },
  hasSummaryLine: false,
  newsletterIcon: {
    icon: "white",
  },
  orientation: "landscape",
  root: {
    containerSize: "medium",
    customCss: css`
      max-inline-size: 100%;
      ${breakpointTheme.breakpoints.up("desktop")} {
        max-inline-size: 100%;
      }
    `,
  },
} as ThemeType;

export const Container = styled.div`
  inline-size: 100%;
  padding-block: 20px;
  padding-inline: 24px;

  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 4px;

  background: #ffffff;

  ${SignUpNewsletterBottom} {
    margin-block-end: -8px;
  }

  ${FindOutMoreContainer} {
    grid-template-areas:
      "Message"
      "Button";
    gap: 16px;
    place-items: center center;
    ${breakpointTheme.breakpoints.up("tablet")} {
      grid-template-areas: "Message Button";
      justify-items: flex-start;
    }

    ${FindOutMoreButton} {
      padding-block: 10px;
      padding-inline: 16px;

      border-radius: 2px;

      background-color: #4585ff;
    }

    ${FindOutMoreMessageContainer} {
      margin-block: 0;
      ${breakpointTheme.breakpoints.up("tablet")} {
        margin-inline-start: 12px;
      }
    }

    ${FindOutMoreButtonContainer} {
      ${breakpointTheme.breakpoints.up("tablet")} {
        justify-self: end;
      }
    }

    ${FindOutMoreMessage} {
      color: #001246;
      ${breakpointTheme.breakpoints.up("tablet")} {
        font-size: 18px;
        line-height: 23px;
      }
    }
    ${FindOutMoreNewsletterIcon} {
      display: none;
    }
  }
`;
